import './PriceCard.scss'

export default function PriceCard({price, number, discount, name}){

    const oneLesson = Math.round(price/number);

    return(
        <div className="PriceCard">
            <div className="container">
                <div className="card_content">
                    <h2>{name}</h2>
                    <div className="number">Кількість занять: {number}</div>
                    <div className="price">
                        <h3>{price} грн</h3>
                        <p>{oneLesson} грн / урок</p>
                    </div>
                    <div className="discount">
                        {discount ?  `Знижка ${discount}%` : "Full price"}
                    </div>
                </div>
                
            </div>
        </div>
    )
}